import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllControlePatrimonioControleUseCase } from "../../../presentation/useCases/read/get_all_controle_patrimonio_controle_use_case";
import { ControleCentroCustoLista } from "../../models/controle_centro_custo_lista";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllControlePatrimonioControleUseCase
 */

export class GetAllControlePatrimonioControleUseCase
  extends BasePaginatedUseCase<ControleCentroCustoLista>
  implements IGetAllControlePatrimonioControleUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllControlePatrimonioControle(
    centroCusto: number[] | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getControlePatrimonioControleList(
      centroCusto,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
